import { CEOrganizationAttributesBase } from './ce-organization-attributes-base'


export class CEOrganizationAttributes extends CEOrganizationAttributesBase {

}